// extracted by mini-css-extract-plugin
export default {"EventFormHeader":"EventFormHeader_EventFormHeader__9VN7Z","content":"EventFormHeader_content__7nkQN"};